import React from 'react';
import { palettes, SmallBody } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircle } from '@fortawesome/pro-regular-svg-icons';

import { createStylesHook } from 'shared/hooks/createStylesHook';

const useStyles = createStylesHook({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0'
  }
});

interface CheckListItem {
  text: string | React.ReactElement;
  completed: boolean;
}

export interface CheckListProps {
  items: CheckListItem[];
}

export const CheckList: React.FunctionComponent<CheckListProps> = ({ items }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {items.map((item, i) => (
        <div key={i} className={classes.item}>
          <FontAwesomeIcon
            size="sm"
            icon={item.completed ? faCheckCircle : faCircle}
            color={item.completed ? palettes.coastal.accent.green : palettes.neutral['700']}
          />
          <SmallBody style={{ marginLeft: 10, maxWidth: 130 }} className="text-transform-capitalize">
            {item.text}
          </SmallBody>
        </div>
      ))}
    </div>
  );
};
